import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ButtonComponent } from 'src/app/elements/button/button.component'
import { FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms'
import { HttpClient } from '@angular/common/http'
import { Environment } from 'src/environments/environment'
import { PageContext, RedirectorPaynowConfig } from 'src/app/service/redirector.service'
import { PopupComponent } from 'src/app/elements/popup/popup.component'
import { CurrencyPipe, NgTemplateOutlet } from '@angular/common'
import { UserTokenPipe } from 'src/app/pipes/promo-link.pipe'

@Component({
  imports: [
    ButtonComponent,
    ReactiveFormsModule,
    CurrencyPipe,
    NgTemplateOutlet,
    UserTokenPipe,
  ],
  selector: 'app-price-suggestion',
  templateUrl: './price-suggestion.component.html',
  styleUrl: './price-suggestion.component.sass',
})
export class PriceSuggestionComponent implements OnInit {
  protected form: FormGroup = new FormGroup<any>({
    email: new FormControl('', [Validators.required, Validators.email]),
    price: new FormControl('', [
      Validators.required,
      (control: FormControl): ValidationErrors | null => {
        return (
          control.value
          && this.data.context.config.price
          && control.value > this.data.context.config.price - 10
        ) ? { max: true } : null
      },
      (control: FormControl): ValidationErrors | null => {
        return (
          control.value
          && this.data.context.config.price
          && control.value < (this.data.context.config.price * .25)
        ) ? { offer_price: true } : null
      },
      Validators.min(99),
    ]),
    domain: new FormControl(this.data.context.config.name, [Validators.required]),
  })
  protected sending: boolean = false
  protected send: boolean = false
  protected touched: boolean = false

  protected control (path: string): FormControl {
    return this.form.get(path) as FormControl
  }

  constructor (
    @Inject(MAT_DIALOG_DATA) protected data: {
      email: string,
      price: string,
      context: PageContext<RedirectorPaynowConfig>,
    },
    @Inject(MatDialogRef) protected dialog: MatDialogRef<PopupComponent>,
    protected http: HttpClient,
  ) {}

  ngOnInit () {
    this.form.patchValue({
      email: this.data.email,
      price: this.data.price,
    })
  }

  submit (event: SubmitEvent) {
    event.preventDefault()
    this.touched = true

    if (this.form.invalid || this.sending) {
      return
    }
    this.sending = true

    this.http.post(
      `${Environment.url.app}/public/api/domain/offers/price/suggest?lang=${this.data.context.i18n.locale}`,
      this.form.value,
    )
      .subscribe(response => {
        this.sending = false
        this.send = true
      })
  }

  close () {
    this.dialog.close()
  }

  cancel (event: MouseEvent) {
    event.preventDefault()
    this.close()
  }
}
